import { checkNewRelicIsEnabled } from "./checkEnabled";

export const setCustomAttribute = (arg0: string, arg1: string) => {
  if (checkNewRelicIsEnabled()) {
    window.newrelic?.setCustomAttribute(arg0, arg1);
  }
};

export const noticeError = (
  message: string,
  options?: { [key: string]: string },
) => {
  if (checkNewRelicIsEnabled()) {
    window.newrelic?.noticeError(message, options);
  }
};
